import type { MascotPose } from "@orbin/core";
import { Mascot } from "@orbin/ui-web";

export type BrandMomentKind =
  | "welcome"
  | "done"
  | "decision"
  | "depleted"
  | "empty-threads"
  | "empty-routines";

const POSES: Record<BrandMomentKind, MascotPose> = {
  welcome: "idle",
  done: "done",
  decision: "decision",
  depleted: "night",
  "empty-threads": "idle",
  "empty-routines": "night",
};

/** The mascot at a brand moment: a first run, a first finish, an empty list, an empty tank. */
export function BrandMoment({
  kind,
  size = 120,
}: {
  kind: BrandMomentKind;
  size?: number;
}) {
  return (
    <div data-testid={`brand-moment-${kind}`} className="flex justify-center">
      <Mascot pose={POSES[kind]} size={size} />
    </div>
  );
}
